import React from 'react';
import { Select, Tooltip } from 'antd';
import { FormattedMessage } from 'react-intl';
import { getRegionOptions } from '../../../Utils/RegionUtils/RegionUtils';
import MultiLocationContext from '../MultiLocationContext';
import message from '../../../Containers/ManualSearchV2/ManualSearchMessages';

const RegionSelect = props => {
  const { isRemoteJobChecked } = props;
  const {
    regionTooltipContent,
    Region,
    onChangeRegion,
    isRegionDisabled,
    regions,
    isAdvanceSearch,
    isPrimaryLocation,
  } = React.useContext(MultiLocationContext);
  return (
    <Tooltip title={!(isAdvanceSearch && isPrimaryLocation) ? regionTooltipContent : ''}>
      <Select
        placeholder={<FormattedMessage {...message.regionsLabel} />}
        style={{ width: '100%' }}
        value={Region?.RegionName}
        onChange={onChangeRegion}
        disabled={isRegionDisabled || isRemoteJobChecked}
        allowClear
        key="Region"
      >
        {getRegionOptions({ regions })}
      </Select>
    </Tooltip>
  );
};

export default RegionSelect;
